import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import boxArchiveSolid from '../../../../assets/images/box-archive-solid.svg'
import paletteOutline from '../../../../assets/images/palette-outline.svg'

const PhotosOptions = ({ onExportAll, onCustomize, currentSectionId }) => {
  const handleExportAllClick = useCallback(() => {
    onExportAll()
  }, [onExportAll])

  const handleCustomizeClick = useCallback(() => {
    onCustomize()
  }, [onCustomize])

  return (
    <div className="export-type">
      <div className="row">
        <div className="col-md-6">
          <div
            className="card"
            role="button"
            tabIndex={0}
            onClick={handleExportAllClick}
          >
            <div className="card-body">
              <div className="text-center mb-3">
                <h4 className="card-title">Exporter toutes les photos</h4>
                <img src={boxArchiveSolid} style={{ height: '3.5rem' }} alt="Export all" />
              </div>
              <p className="card-text text-center">
                {/* eslint-disable multiline-ternary */}
                {currentSectionId
                  ? 'Téléchargez toutes les photos de cette section en un seul fichier ZIP.'
                  : 'Téléchargez toutes les photos de cette collecte en un seul fichier ZIP.'}
                {/* eslint-enable multiline-ternary */}
              </p>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div
            className="card"
            role="button"
            tabIndex={0}
            onClick={handleCustomizeClick}
          >
            <div className="card-body">
              <div className="text-center mb-3">
                <h4 className="card-title">Personnaliser l&apos;export</h4>
                <img src={paletteOutline} style={{ height: '3.5rem' }} alt="Customize" />
              </div>
              <p className="card-text text-center">
                Sélectionnez des sections et questions spécifiques pour un export ciblé.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

PhotosOptions.propTypes = {
  currentSectionId: PropTypes.number,
  onCustomize: PropTypes.func.isRequired,
  onExportAll: PropTypes.func.isRequired
}

PhotosOptions.defaultProps = {
  currentSectionId: null
}

export default PhotosOptions